module.exports = __webpack_public_path__ + "static/media/4.ffc7ac4f.jpg";